import Api from '@/helpers/Api.js';
import Vue from 'vue';

// Import mutations
import {
    SET_PARAMETERS,
    UPDATE_PARAMETER
} from './mutation-types.js';

const resource = '/internal/v1/parameters';

// Initial state
const state = () => ({
    parameters:               [],
    ARCHIVE_CONVERSATION:     'archive_conversation',
    SESSION_INACTIVITY_DELAY: 'session_inactivity_delay'
});

// Getters
const getters = {
    /**
     * Archive_conversation SMS parameter
     *
     * @param {object} state
     *
     * @return array
     */
    getArchiveConversationParameter: (state) => {
        return state.parameters.find((parameter) => parameter.attributes.name === state.ARCHIVE_CONVERSATION) ?? null;
    },

    /**
     * Session inactivity delay parameter
     *
     * @param {object} state
     *
     * @return array
     */
    getInactivitySessionParameter: (state) => state.parameters.find((parameter) => parameter.attributes.name === state.SESSION_INACTIVITY_DELAY) ?? null
};

// Actions
const actions = {
    /**
     * Get a list of parameters.
     *
     * @param   {Object}  context  The context
     *
     * @return  {Promise}
     */
    index: (context) => new Promise((resolve, reject) => {
        Api.get(`${resource}`)
            .then((response) => {
                context.commit(SET_PARAMETERS, response.data.data);
                resolve(response.data.data);
            })
            .catch((error) => {
                reject(error);
            });
    }),

    /**
     * Update a parameter
     *
     * @param   {Object}  context     The context
     * @param   {string}  id          The parameter id
     * @param   {Object}  attributes  The parameter new attributes
     *
     * @return  {Promise}
     */
    update: (context, { id, attributes }) => new Promise((resolve, reject) => {
        Api.patch(`${resource}/${id}`, {
            'data': {
                'type': 'parameters',
                id,
                attributes
            }
        })
            .then((response) => {
                context.commit(UPDATE_PARAMETER, response.data.data);
                resolve(response.data.data);
            })
            .catch((error) => {
                reject(error);
            });
    })
};

// Mutations
const mutations = {
    [SET_PARAMETERS]: (state, payload) => {
        state.parameters = payload;
    },
    [UPDATE_PARAMETER]: (state, payload) => {
        const index = state.parameters.findIndex(parameter => parameter.id === payload.id);
        Vue.set(state.parameters, index, payload);
    }
};

// Export module
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
